module.exports = __webpack_public_path__ + "static/media/rawfish.7a889a38.webp";